import { request } from '@/network/request'

export function profile () {
  return request({
    url: '/system/user/profile/userInfo',
  });
}

export const updateProfile=(user)=>{
  return request({
    url: '/system/user/profile/updateProfile',
    method:'put',
    data:user
  })
};

//密码修改
export const updatePwd=(data)=>{
  return request({
    url: '/system/user/profile/updatePwd',
    method:'put',
    params:data
  });
}


////获取过敏原
export function getAllergen () {
  return request({
    url: '/userManagement/user/getAllergen',
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js